import { IconButton, Menu, MenuItem } from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  DialogContentText,
  Button,
  TextField,
} from "@material-ui/core";
import {
  BILLING_VISIT_FINANCIAL_SUMMARY_MORE_MENU_OPTIONS,
  PATIENT_VISIT_INTERNAL_STATUS,
  VISIT_BILLING_STATUS,
  HMS_PAYMENT_REUQEST_STATUS,
  HMS_PAYMENT_REUQEST_TYPE,
  CANCEL_INVOICE,
} from "../../core/constants/erpConstants";
import erpActions from "./ERPActions/erpActions";
import ConfirmDeleteDialog from "./ConfirmDeleteDialog";
import { helperServices } from "../../shared/helper";
import { useOrganization } from "../../configurations/OrganizationContext";
import {
ORG_CODES
} from "../../shared/constants";

const MoreOptionsMenu = ({
  itemsToShow,
  invoice,
  visitInternalStatus,
  billingStatus,
  onClose,
  disabled,
}) => {
  const org = useOrganization();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const patientInfo = useSelector(
    (state) => state.patientDetailsState.patientBasic,
  );

  const userName = helperServices.getLoggedUserID();

  const [paymentRequest, setPaymentRequest] = useState({});
  const [openConfirm, setOpenConfirm] = useState(false);
  const [selectedInvoice, setSelectedInvoice] = useState(null);
  const [deleteReason, setDeleteReason] = useState("");
  const [pendingDelete, setPendingDelete] = useState(null);
  const isOrgRestricted = org?.orgCode === ORG_CODES.MANASWINI;

  const handleOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
    onClose("reloadpage");
  };

  useEffect(() => {
    let loggedINUserID = helperServices.getLoggedUserGVID();
    let loggedINUserName = helperServices.getLoggedUserName();

    setPaymentRequest((prev) => ({
      ...prev,
      patientId: patientInfo.id,
      visitId: patientInfo.visitId,
      requestedById: loggedINUserID,
      requestedByName: loggedINUserName,
      cby: loggedINUserID,
      uby: loggedINUserID,
      type: HMS_PAYMENT_REUQEST_TYPE.ADVANCE_REQUEST,
      status: HMS_PAYMENT_REUQEST_STATUS.PAYMENT_REQUEST_REQUESTED,
    }));
  }, []);

  const handleConvertType = async (menuItem, obj) => {
    if (
      BILLING_VISIT_FINANCIAL_SUMMARY_MORE_MENU_OPTIONS.CONVERT_TO_CASH_KEY ===
      menuItem
    ) {
      await erpActions.updateConvertKpCashKPCreditInvoice(obj.ticketId, true);
    }

    if (
      BILLING_VISIT_FINANCIAL_SUMMARY_MORE_MENU_OPTIONS.CONVERT_TO_CREDIT_KEY ===
      menuItem
    ) {
      await erpActions.updateConvertKpCashKPCreditInvoice(obj.ticketId, false);
    }
  };

  const handleAction = async (menuItem, type, objDetail) => {
    if (type === "convert") {
      await handleConvertType(menuItem, objDetail);
    }
    handleClose();
  };

  const handleAddPaymentRequestMethod = async (amount, objDetail) => {
    paymentRequest.requestedAmount = -amount;
    paymentRequest.description = objDetail.invoiceId + " Refund";

    await erpActions.savePaymentRequests(
      paymentRequest.patientId,
      paymentRequest.visitId,
      paymentRequest,
    );
  };

  const handleDeleteInvoice = async (objDetail) => {
    const amount = parseFloat(objDetail.receivedAmt.replace("₹", "").trim());

    if (amount !== 0) {
      await handleAddPaymentRequestMethod(amount, objDetail);
    }

    await erpActions.removeInvoice(objDetail, userName);
    setOpenConfirm(false);
    setDeleteReason("");
    setAnchorEl(null);
    onClose("reloadpage");
  };

  const openInvoiceDeleteDialog = () => {
    setPendingDelete(
      () => () =>
        handleDeleteInvoice({
          ...invoice,
          deleteReason,
        }),
    );

    setOpenConfirm(true);
  };

  const showMenuItem = (menuKey) => {
    if (!itemsToShow?.includes(menuKey)) return false;

    const ALLOWED_VISIT_INTERNAL_STATUSES = [
      PATIENT_VISIT_INTERNAL_STATUS.OPEN,
      PATIENT_VISIT_INTERNAL_STATUS.BOOKED,
    ];

    if (
      visitInternalStatus &&
      !ALLOWED_VISIT_INTERNAL_STATUSES.includes(visitInternalStatus)
    ) {
      return false;
    }

    if (
      billingStatus &&
      billingStatus === VISIT_BILLING_STATUS.BILLING_STATUS_DISABLED
    ) {
      return false;
    }

    return true;
  };

  return (
    <>
      <IconButton
        size="small"
        onClick={handleOpen}
        disabled={disabled}
        aria-label="more options"
      >
        <MoreVertIcon fontSize="small" />
      </IconButton>

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
      >
        {!isOrgRestricted && (
          <>
            {showMenuItem(
              BILLING_VISIT_FINANCIAL_SUMMARY_MORE_MENU_OPTIONS.CONVERT_TO_CREDIT_KEY,
            ) && (
              <MenuItem
                onClick={() =>
                  handleAction(
                    BILLING_VISIT_FINANCIAL_SUMMARY_MORE_MENU_OPTIONS.CONVERT_TO_CASH_KEY,
                    "convert",
                    invoice,
                  )
                }
              >
                {
                  BILLING_VISIT_FINANCIAL_SUMMARY_MORE_MENU_OPTIONS.CONVERT_TO_CASH_LABEL
                }
              </MenuItem>
            )}

            {showMenuItem(
              BILLING_VISIT_FINANCIAL_SUMMARY_MORE_MENU_OPTIONS.CONVERT_TO_CASH_KEY,
            ) && (
              <MenuItem
                onClick={() =>
                  handleAction(
                    BILLING_VISIT_FINANCIAL_SUMMARY_MORE_MENU_OPTIONS.CONVERT_TO_CREDIT_KEY,
                    "convert",
                    invoice,
                  )
                }
              >
                {
                  BILLING_VISIT_FINANCIAL_SUMMARY_MORE_MENU_OPTIONS.CONVERT_TO_CREDIT_LABEL
                }
              </MenuItem>
            )}

            <MenuItem
              onClick={() => {
                handleClose();
                setSelectedInvoice(invoice);
                openInvoiceDeleteDialog();
              }}
            >
              {CANCEL_INVOICE}
            </MenuItem>
          </>
        )}
      </Menu>

      <ConfirmDeleteDialog
        open={openConfirm}
        title="Cancel Invoice"
        message="Are you sure you want to cancel this invoice?"
        showReason={true}
        reason={deleteReason}
        onReasonChange={setDeleteReason}
        onCancel={() => {
          setOpenConfirm(false);
          setDeleteReason("");
        }}
        onConfirm={async () => {
          if (pendingDelete) await pendingDelete();

          setOpenConfirm(false);
          setDeleteReason("");
        }}
      />
    </>
  );
};

export default MoreOptionsMenu;
